export const getWithSale = (value: number, sale: number): number => {
	return Math.ceil(value - value * (sale / 100))
}
